import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { MultiDocumentUploaderProvider } from '@/modules/documents/MultiDocumentUploader/context/MultiDocumentUploader.provider';
import { ROUTE_KEYS } from '@/navigation/constants';
import { WorkflowTrackerKind } from '@/types/schema';

import { ClientOnboardingDeliverableModalBodyProps } from '../../types';
import { GenericDocumentProcessingModalBody } from './GenericDocumentProcessingModalBody';

function SummarizeDocumentModalBodyInner(
  props: ClientOnboardingDeliverableModalBodyProps
) {
  const config = {
    allowSelectExistingDocuments: false,
    subheader:
      'Luminary AI will process and summarize each document. Once complete, you can edit, regenerate, or share a summary with your client.',
    workflowTrackerKind: WorkflowTrackerKind.DocumentSummary,
    useAIWorkflow: false,
    processingHeader: (documentNoun: string) =>
      `Summarizing ${documentNoun}...`,
    processingSubheader: (
      <>
        We are processing your documents and will notify you when your document
        summaries are ready for review.
        <strong> This process may take up to several minutes.</strong>
      </>
    ),
    successHeader: 'Success! Documents summarized',
    successSubheader: 'Your document summaries are ready for your review',
    errorMessage:
      'We failed to summarize these documents. Please upload new documents to try again.',
    completionButtonLabel: 'Continue to documents',
    onCompletionClick: (
      navigate: ReturnType<typeof useNavigateToRoute>['navigate'],
      householdId: string
    ) => {
      navigate(ROUTE_KEYS.HOUSEHOLD_DETAILS_DOCUMENTS, {
        householdId,
      });
    },
  };

  return <GenericDocumentProcessingModalBody {...props} config={config} />;
}

export function SummarizeDocumentModalBody(
  props: ClientOnboardingDeliverableModalBodyProps
) {
  return (
    <MultiDocumentUploaderProvider>
      <SummarizeDocumentModalBodyInner {...props} />
    </MultiDocumentUploaderProvider>
  );
}
